export const SALARIES_API_ENDPOINT_ROOT = '/data/salary-surveys/v8';
